{
  "page_forside_title": "Helsenorge – din helse på nett",
  "fastlegepanel_title": "Din fastlege",
  "fastlegepanel_description": "Kontakt fastlegen og se alle tjenestene",
  "tjenestepanelVisFlere": "Se flere tjenester",
  "tjenestepanelVisFarre": "Vis færre tjenester",
  "savnerDuTjenesterTitle": "Savner du noen tjenester?",
  "savnerDuTjenesterDescription": "Du har ikke samtykket til følgende tjenester:",
  "savnerDuTjenesterTimeavtaler": "Timeavtaler og henvisninger",
  "savnerDuTjenesterPasientreiser": "Pasientreiser",
  "savnerDuTjenesterDialog": "Dialog med helsekontakter",
  "savnerDuTjenesterButton": "Endre samtykke",
  "savnerDuTjenesterFullmektigButton": "Se samtykke",
  "inactivity_SignedOut_Button_GoToRoot": "Gå til forsiden",
  "inactivity_SignedOut_Button_SignInAgain": "Logg inn på nytt",
  "inactivity_SignedOut_Title": "Du var stille en stund og har blitt logget ut",
  "inactivity_LoginUrl": "/auth/signin",
  "signedOut_SignedOut_Title": "Du er logget ut",
  "signedOut_SignedOut_Explanation": "Du er nå logget ut",
  "notificationPanelFullSamtykke": "Du har gitt samtykke til Basis eller Basis+. Du har derfor bare tilgang til et utvalg av tjenestene på Helsenorge. Hvis du vil ha tilgang til alle tjenestene, må du endre samtykket ditt til Full. Hvis du er under 16 år, må dine foresatte endre samtykket for deg.",
  "notificationPanelInnsynssperre": {
    "type": "markdown",
    "value": "Du har sperret din tilgang til innloggede tjenester på Helsenorge. For å oppheve sperren må du sende inn skjema for å gjenåpne tilgangen.\n\n[Skjema for voksne](https://www.helsenorge.no/48d643/globalassets/skjema/tilgangssperre/hn-sperre-gjenaapne-helsenorge.pdf)\n\n[Skjema for barn under 16 år](https://www.helsenorge.no/48d667/globalassets/skjema/tilgangssperre/hn-sperre-gjenaapne-helsenorge-barn.pdf)"
  },
  "digitalt_inaktiv_beskrivelse": {
    "type": "markdown",
    "value": "Du har valgt å ikke bruke Helsenorge selv. Den du har gitt fullmakt til, vil fremdeles kunne bruke tjenestene og lese meldinger om det som gjelder deg.\n\nHvis du vil bruke Helsenorge igjen, må du fylle ut og sende inn dette skjemaet: [Skjema for å bli aktiv igjen på Helsenorge.](https://www.helsenorge.no/4911d4/globalassets/skjema/inaktiv/hn-skjema-inaktiv-1.pdf)"
  },
  "digitalt_inaktiv_representasjon_tittel": "{navn} er inaktiv på Helsenorge",
  "digitalt_inaktiv_tittel": "Du er inaktiv på Helsenorge",
  "digitalt_inaktiv_representasjon_beskrivelse": {
    "type": "markdown",
    "value": "{navn} som du har fullmakt til å bruke Helsenorge på vegne av, har valgt å ikke lenger bruke Helsenorge. Det betyr at {navn} ikke kan bruke tjenestene og ikke vil få varsler og meldinger på Helsenorge.\n\nFor å kunne bruke Helsenorge selv igjen må {navn} sende inn dette skjemaet: [Skjema for å bli aktiv igjen på Helsenorge](https://www.helsenorge.no/globalassets/skjema/inaktiv/hn-skjema-inaktiv-1.pdf)."
  },
  "se_mer": "Se mer",
  "se_mindre": "Se mindre",
  "sharing_Status_Delt_Med_Barnet": "Delt med barnet",
  "foreldresamtykke_representasjon_tittel": "{navn} har egen tilgang til Helsenorge",
  "foreldresamtykke_representasjon_beskrivelse": {
    "type": "markdown",
    "value": "{navn} har foreldresamtykke til å bruke noen av tjenestene på Helsenorge. [Les mer om hvilke tjenester ungdommen din har tilgang til](helsenorgeUrl/om-tjenestene/foreldresamtykke-ungdomstilgang/)"
  }
}
